import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useMemo, useRef, useState } from "react";
import { useSellCarData } from "@/common/Contexts/SellCarDataContext";
import { useScreenNavigation } from "@/common/Contexts/ScreenNavigationContext";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import usePaymentHook from "@/pages/checkout/CheckoutV2/hooks/usePaymentHook";
import useIsIOS from "@hooks/useIsIOS";
import "./MoyasarSellTradeStyleOverRide.css";
import { If } from "@componentsShared/Conditional/If";
import SAR from "@componentsShared/SAR/SAR";
import { SELL_CAR_SCREENS } from "@/pages/sell-my-car/constants/screens";
import useWebview from "@hooks/useWebview";
import FLowLoadingSpinner from "@/pages/sell-my-car/components/FLowLoadingSpinner";
import { getStepValidation } from "@/apis/sell-my-car";
import useBFCacheBuster from "@hooks/useBFCacheBuster";
import useIsWebView from "@hooks/useIsWebview";
var DIV_ID = ".mysr-form";
var CarPaymentScreen = function CarPaymentScreen() {
  var _state$draftOrder, _state$draftOrder3, _state$draftOrder7, _state$draftOrder8, _state$draftOrder9, _state$draftOrder9$cu, _state$draftOrder9$cu2, _state$draftOrder0, _state$draftOrder0$cu, _state$draftOrder0$cu2;
  useBFCacheBuster();
  var divRef = useRef(null);
  var is_ios = useIsIOS();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useSellCarData = useSellCarData(),
    state = _useSellCarData.state,
    actions = _useSellCarData.actions;
  var _useScreenNavigation = useScreenNavigation(),
    navActions = _useScreenNavigation.actions;
  var _useState = useState(null),
    paymentSession = _useState[0],
    setPaymentSession = _useState[1];
  var _useState2 = useState("moyasar"),
    gatewayType = _useState2[0],
    setGatewayType = _useState2[1];
  var _useState3 = useState(true),
    paymentFailed = _useState3[0],
    setPaymentFailed = _useState3[1];

  // Get payment redirect params from context (saved by SellMyCarRoot before clearing URL)
  var paymentRedirectParams = state === null || state === void 0 ? void 0 : (_state$draftOrder = state.draftOrder) === null || _state$draftOrder === void 0 ? void 0 : _state$draftOrder.paymentRedirectParams;

  // Fallback to URL params if context is empty
  var queryParams = new URLSearchParams(location.search);
  var statusArray = queryParams.getAll("status");
  var messageArray = queryParams.getAll("message");
  var requestIdArray = queryParams.getAll("request_id");
  var status = (paymentRedirectParams === null || paymentRedirectParams === void 0 ? void 0 : paymentRedirectParams.status) || (statusArray.length > 0 ? statusArray[statusArray.length - 1] : undefined);
  var message = (paymentRedirectParams === null || paymentRedirectParams === void 0 ? void 0 : paymentRedirectParams.message) || (messageArray.length > 0 ? messageArray[messageArray.length - 1] : undefined);
  var urlRequestId = requestIdArray.length > 0 ? requestIdArray[requestIdArray.length - 1] : undefined;
  var webview = useWebview();
  var isWebView = useIsWebView();
  var height = useMemo(function () {
    var _window;
    if (__IS_SSR__) {
      return "fit-content";
    }
    if (isWebView) {
      return "fit-content";
    }
    return ((_window = window) === null || _window === void 0 ? void 0 : _window.innerHeight) - 160 + "px";
  }, [isWebView, __IS_SSR__]);

  // Handle payment success/failure from redirect
  useEffect(function () {
    var _state$draftOrder2;
    // Use requestId from context or fallback to URL param
    var requestId = (state === null || state === void 0 ? void 0 : (_state$draftOrder2 = state.draftOrder) === null || _state$draftOrder2 === void 0 ? void 0 : _state$draftOrder2.requestId) || urlRequestId;
    if (status === "paid" && message === "APPROVED") {
      // Add delay to wait for webhook to update the backend
      var delay = setTimeout(function () {
        // Navigate to payment success screen (which will fetch next step from backend)
        webview.openScreen("payment_success", {
          request_id: requestId
        }).then();
        navActions.navigateToScreen(SELL_CAR_SCREENS.PAYMENT_SUCCESS);
      }, 2000);
      return function () {
        return clearTimeout(delay);
      };
    } else if (status && requestId) {
      var _delay = setTimeout(function () {
        // Redirect to payment failed page
        webview.openScreen("payment_failed", {
          request_id: requestId
        }).then();

        // Redirect to dedicated payment failed page
        navigateTo("/site/sell-my-car/payment-failed/".concat(requestId));
      }, 2000);
    }
  }, [status, message, navActions, webview, state === null || state === void 0 ? void 0 : (_state$draftOrder3 = state.draftOrder) === null || _state$draftOrder3 === void 0 ? void 0 : _state$draftOrder3.requestId, urlRequestId, navigateTo]);
  var on_initiating = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _state$draftOrder4;
      var requestId, response, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            requestId = (state === null || state === void 0 ? void 0 : (_state$draftOrder4 = state.draftOrder) === null || _state$draftOrder4 === void 0 ? void 0 : _state$draftOrder4.requestId) || urlRequestId;
            if (requestId) {
              _context.n = 1;
              break;
            }
            return _context.a(2, false);
          case 1:
            _context.p = 1;
            _context.n = 2;
            return getStepValidation({
              request_id: requestId
            });
          case 2:
            response = _context.v;
            return _context.a(2, (response === null || response === void 0 ? void 0 : response.step_key) === SELL_CAR_SCREENS.FEES_PAYMENT);
          case 3:
            _context.p = 3;
            _t = _context.v;
            console.log("Payment session validation failed");
            return _context.a(2, false);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function on_initiating() {
      return _ref.apply(this, arguments);
    };
  }();
  var on_completed = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function on_completed() {
      return _ref2.apply(this, arguments);
    };
  }();

  // Payment component that only renders when we have valid payment session
  var PaymentComponent = function PaymentComponent() {
    if (!paymentSession) return null;
    usePaymentHook({
      divSelector: DIV_ID,
      paymentSession: paymentSession,
      events: {
        on_initiating: on_initiating,
        on_completed: on_completed
      },
      template: {
        payButtonText: tShort("sell_trade_v2/complete_payment", {
          ns: "web_sell_trade"
        })
      },
      internvalTimeoutSeconds: 5,
      gatewayType: gatewayType
    });
    return null;
  };
  useEffect(function () {
    if (divRef.current) {
      // Setting styles with `!important`
      divRef.current.style.setProperty("max-width", "100%", "important");
    }
  }, []);

  // Fetch step data on mount only if payment info is not already loaded
  useEffect(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _state$draftOrder5, _state$draftOrder5$cu, _state$draftOrder5$cu2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(state !== null && state !== void 0 && (_state$draftOrder5 = state.draftOrder) !== null && _state$draftOrder5 !== void 0 && (_state$draftOrder5$cu = _state$draftOrder5.currentStep) !== null && _state$draftOrder5$cu !== void 0 && (_state$draftOrder5$cu2 = _state$draftOrder5$cu.data) !== null && _state$draftOrder5$cu2 !== void 0 && _state$draftOrder5$cu2.payment_info)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              if (!(actions !== null && actions !== void 0 && actions.fetchStepData)) {
                _context3.n = 2;
                break;
              }
              _context3.n = 2;
              return actions.fetchStepData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function fetchData() {
        return _ref3.apply(this, arguments);
      };
    }();
    fetchData();
  }, []);

  // Extract payment info from step data
  useEffect(function () {
    var _state$draftOrder6, _state$draftOrder6$cu, _state$draftOrder6$cu2;
    var paymentInfo = state === null || state === void 0 ? void 0 : (_state$draftOrder6 = state.draftOrder) === null || _state$draftOrder6 === void 0 ? void 0 : (_state$draftOrder6$cu = _state$draftOrder6.currentStep) === null || _state$draftOrder6$cu === void 0 ? void 0 : (_state$draftOrder6$cu2 = _state$draftOrder6$cu.data) === null || _state$draftOrder6$cu2 === void 0 ? void 0 : _state$draftOrder6$cu2.payment_info;
    if (paymentInfo) {
      setPaymentSession(paymentInfo.paymentSession);
      setGatewayType(paymentInfo.gateway_type || "moyasar");
    }

    // Cleanup: Reset payment session state when component unmounts
    return function () {
      setPaymentSession(null);
      setGatewayType("moyasar");
    };
  }, [state === null || state === void 0 ? void 0 : (_state$draftOrder7 = state.draftOrder) === null || _state$draftOrder7 === void 0 ? void 0 : _state$draftOrder7.currentStep]);

  // Show loader while fetching step data
  if (state !== null && state !== void 0 && (_state$draftOrder8 = state.draftOrder) !== null && _state$draftOrder8 !== void 0 && _state$draftOrder8.isLoadingStepData) {
    return /*#__PURE__*/React.createElement("div", {
      className: "p-4 flex items-center justify-center h-full"
    }, /*#__PURE__*/React.createElement(FLowLoadingSpinner, null));
  }

  // Show loader only for successful payment redirect
  if (status === "paid" && message === "APPROVED") {
    return /*#__PURE__*/React.createElement("div", {
      className: "p-4 flex items-center justify-center h-full"
    }, /*#__PURE__*/React.createElement(FLowLoadingSpinner, null));
  }
  var handleRetryPayment = function handleRetryPayment() {
    // Remove status and message params from URL to retry payment
    var url = new URL(window.location.href);
    url.searchParams["delete"]("status");
    url.searchParams["delete"]("message");
    window.location.href = url.toString();
  };
  var paymentAmount = (state === null || state === void 0 ? void 0 : (_state$draftOrder9 = state.draftOrder) === null || _state$draftOrder9 === void 0 ? void 0 : (_state$draftOrder9$cu = _state$draftOrder9.currentStep) === null || _state$draftOrder9$cu === void 0 ? void 0 : (_state$draftOrder9$cu2 = _state$draftOrder9$cu.data) === null || _state$draftOrder9$cu2 === void 0 ? void 0 : _state$draftOrder9$cu2.fees_amount) || 0;
  var carName = state === null || state === void 0 ? void 0 : (_state$draftOrder0 = state.draftOrder) === null || _state$draftOrder0 === void 0 ? void 0 : (_state$draftOrder0$cu = _state$draftOrder0.currentStep) === null || _state$draftOrder0$cu === void 0 ? void 0 : (_state$draftOrder0$cu2 = _state$draftOrder0$cu.data) === null || _state$draftOrder0$cu2 === void 0 ? void 0 : _state$draftOrder0$cu2.car_name;
  return /*#__PURE__*/React.createElement("div", {
    id: "sell-car-payment-screen",
    className: "relative p-4 md:p-6",
    style: {
      maxHeight: height,
      overflowY: "auto"
    }
  }, /*#__PURE__*/React.createElement("style", null, "\n        .mysr-form div#mysr #mysr-form-submit {\n          position: relative;\n          \n        }\n        .mysr-form div#mysr #mysr-cc-name, \n        .mysr-form div#mysr #mysr-cc-number,\n        .mysr-form div#mysr #mysr-cc-exp,\n        .mysr-form div#mysr #mysr-cc-csc {\n          font-size: 16px !important;\n      \n        }\n        .mysr-form div#mysr #mysr-cc-name:placeholder,\n          .mysr-form div#mysr #mysr-cc-number:placeholder,\n          .mysr-form div#mysr #mysr-cc-exp:placeholder,\n          .mysr-form div#mysr #mysr-cc-csc:placeholder {\n          font-size: 16px !important;\n        }\n        \n      "), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-payment-car-info",
    className: "rounded border border-solid border-gray-echo bg-white flex flex-col mb-10"
  }, /*#__PURE__*/React.createElement(If, {
    condition: !!carName
  }, /*#__PURE__*/React.createElement("h4", {
    id: "sell-car-payment-car-name",
    className: "p-4 text-black-primary text-base font-bold leading-6 text-start border-b border-solid border-gray-echo md:text-xl"
  }, carName)), /*#__PURE__*/React.createElement(If, {
    condition: !!paymentAmount
  }, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-payment-fees-section",
    className: "p-3 flex items-center justify-between border-t border-gray-echo"
  }, /*#__PURE__*/React.createElement("strong", {
    id: "sell-car-payment-fees-label",
    className: "text-black-primary text-sm font-bold leading-6 md:text-xl"
  }, tShort("sell_trade_v2/inspection_fees", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-primary-new text-xl font-bold flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("p", {
    id: "sell-car-payment-fees-amount",
    className: "text-success font-bold text-base md:text-2xl"
  }, paymentAmount), /*#__PURE__*/React.createElement(SAR, {
    className: "text-success text-base md:text-2xl"
  })), /*#__PURE__*/React.createElement("p", {
    id: "sell-car-payment-fees-note",
    className: "text-start text-black-primary text-[10px] leading-4 md:text-sm"
  }, tShort("sell_trade_v2/not_refundable", {
    ns: "web_sell_trade"
  })))))), is_ios && /*#__PURE__*/React.createElement("strong", {
    id: "sell-car-payment-method-label",
    className: "block text-center text-gray-text text-sm font-bold leading-6 mb-6"
  }, tShort("sell_trade_v2/choose_payment_method", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-payment-form-container",
    ref: divRef,
    className: "mysr-form w-full",
    style: {
      maxWidth: "100%"
    }
  }), /*#__PURE__*/React.createElement(PaymentComponent, null));
};
export default CarPaymentScreen;